export default {
  methods: {
    isValidFirstName(value) {
      if (value && value.length < 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    isValidLastName(value) {
      if (value && value.length < 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    isValidEmailAddress(value) {
      if (value && value.length < 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },
    isValidPassword(value) {
      if (value && value.length < 2) {
        return 'TOO_SHORT';
      } else if (!value) {
        return 'EMPTY';
      } else {
        return true;
      }
    },

    isRealEmailAddress: (t => emailAddress => t.reduce((v, r) => v || r.test(emailAddress), false) === false)([
      /^no(.{1})?reply(.*)?@/i, // noreply@ no-reply@ noreply...@
      /@no(.{1})?reply./i, // @noreply.. @no-reply...
      /^do(.{1})?not(.{1})?reply(.*)?@/i, // donotreply@ do-not-reply@ do_not_reply@
      /^sales@/i, // sales@
      /^info@/i, // info@
      /^support@/i, // support@
      /^notifications@/i, // notifications@
      /^postmaster@/i, // postmaster@
    ]),
    parseEmailDisplayName(displayName) {
      // Strip out (via Google Docs) (via Google Drive) (via Something or other)
      displayName = displayName.trim().replace(/\(via [^)]+\)$/i, '');

      const [ firstName, ...otherNames ] = displayName.trim().split(' ');
      return { firstName, lastName: otherNames.join(' ') };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validations.js